import moment from "moment";
import React from "react";
import { Button } from "react-bootstrap";
import { OrderUnit } from "modules/shared/components/digitalized-orders/data-display/OrderUnit";
import { useDispatch, useSelector } from "react-redux";
import { ErrorList } from "shared/components";
import { PriceSummary } from "../../../shared/components/digitalized-orders/data-display/PriceSummary";
import { MoneyFormatter } from "../../../shared/helpers/money/moneyFormatter";
import { OrderCreationPriceCalculator } from "../../../shared/helpers/digitalized-orders/orderCreationPriceCalculator";
import { submitDigitalizedOrder } from "../orderCreationActions";

export const Overview = props => {
  const storeData = useSelector(s => s.slices.orderCreation.storeInfo);
  const { orderUnits, freeProducts, hasFreeProducts } = useSelector(
    s => s.slices.orderCreation.orderUnitsInfo,
  );
  const errorMessages = useSelector(s => s.app.submitErrorMessages);
  const dispatch = useDispatch();

  const handleSubmission = () => {
    dispatch(
      submitDigitalizedOrder({
        requestData: {
          orderCreation: {
            orderUnitsInfo: { orderUnits },
            freeProducts,
            hasFreeProducts,
            storeInfo: storeData,
          },
        },
      }),
    );
  };

  const orderMethodCapitalised =
    storeData?.orderMethod.charAt(0).toUpperCase() +
    storeData?.orderMethod.slice(1);

  return (
    <div className="order-overview-page">
      <h3 className="main-heading">Zusammenfassung</h3>
      <div className="divider" />
      <p className="info-text">
        Bitte überprüfe Deine Angaben sorgfältig.
        <br />
        Nachdem Du den Auftrag abgeschickt hast, bekommt der ausgewählte Markt
        eine Bestätigung und Du den passenden
        <br />
        Lieferschein per E-Mail zugeschickt.
      </p>
      <div className="divider" />
      <div className="overview-box">
        <h4>{storeData?.store?.name}</h4>
        <p>
          <strong>Bestelldatum</strong>{" "}
          {moment(storeData?.orderDate).format("DD.MM.YYYY")}
        </p>
        <p>
          <strong>Bestellart:</strong> {orderMethodCapitalised}
        </p>
        <p>
          <strong>Ansprechpartner:</strong> {storeData?.contactPerson}
        </p>
        <p>
          <strong>Weitere Notizen:</strong> {storeData?.furtherInformation}
        </p>
      </div>

      <h4>Bestelleinheiten</h4>

      {orderUnits?.map((ou, index) => (
        <OrderUnit
          orderUnit={ou?.orderUnit}
          count={ou?.orderUnitCount}
          isFree={false}
          key={index}
        />
      ))}

      <h4>Naturalrabatt</h4>

      {hasFreeProducts ? (
        freeProducts?.map((fp, index) => (
          <OrderUnit
            orderUnit={fp?.orderUnit}
            count={fp?.count}
            isFree
            key={index}
          />
        ))
      ) : (
        <p>Diese Bestellung enthält keine Naturalrabatte oder Gratisware.</p>
      )}

      <PriceSummary
        price={MoneyFormatter.fromBigCents(
          OrderCreationPriceCalculator.getOrderPriceWithVAT(
            orderUnits,
            freeProducts,
          ),
        )}
        withVAT
      />
      <div className="buttons-wrapper">
        <Button
          className="btn btn-secondary"
          onClick={props.navigatePreviousPage}
        >
          Zurück
        </Button>
        <Button className="btn btn-secondary" onClick={handleSubmission}>
          Bestellung abschicken
        </Button>
      </div>
      <ErrorList errorMessages={errorMessages} />
    </div>
  );
};
